import { FormCheck, FormDone, FormFail, Pay3D } from './DefaultTemplate'
import { FormInitial } from './DefaultPassportTemplate'
import { FORM } from '@pay24/common/src/store/PaymentStore'
import { PaymentStore } from '@pay24/common/src/store'
import { Input } from '../Input'
import Spacer from '../Spacer'
import { observer } from 'mobx-react'
import React from 'react'
import * as yup from 'yup'

const FormBase = observer((props) => {
  const { service } = props
  const { payData } = PaymentStore

  const valid_fields = {
    email: yup.string().required('Введите email'),
  }

  const renderFields = (errors) => {
    const fields = service.data && service.data.fields
    if (!fields || fields.length === 0 || Object.keys(fields).length === 0) {
      return null
    }

    const email = fields.find((value) => value.name === 'email')

    return (
      <>
        <Input
          testID="email_text"
          errorText={errors?.email}
          label={email.name}
          value={payData.getOptions(email.name)}
          onChangeText={(val) => {
            PaymentStore.payData.setOptions(email.name, val)
          }}
        />
        <Spacer />
      </>
    )
  }

  return (
    <FormInitial
      {...props}
      customFields={renderFields}
      valid_fields={valid_fields}
    />
  )
})

export default (isAgent) => {
  if (isAgent) {
    return {
      steps: 4,
      [FORM.INITIAL]: FormBase,
      [FORM.CHECK]: FormCheck,
      [FORM.PAID]: FormDone,
      [FORM.FAIL]: FormFail,
    }
  }
  return {
    steps: 5,
    [FORM.INITIAL]: FormBase,
    [FORM.CHECK]: FormCheck,
    [FORM.PAYMENT_3D]: Pay3D,
    [FORM.PAID]: FormDone,
    [FORM.FAIL]: FormFail,
  }
}
